type LocalProperties = Record<string, WithValue>;

const getMappedProperties = (playlistGraphic: PlaylistGraphic | null) => {
	if (!playlistGraphic || !playlistGraphic.graphic) return null;

	return playlistGraphic.graphic.properties.reduce<LocalProperties>((acc, property) => {
		acc[property.id] = {
			...property,
			value: playlistGraphic.propertiesValues[property.id] ?? property.defaultValue ?? "",
		};
		return acc;
	}, {});
};

const getPropertiesValues = (properties: LocalProperties) =>
	Object.values(properties).reduce<PropertyValue>((acc, property) => {
		acc[property.id] = property.value;
		return acc;
	}, {});

export type { LocalProperties };
export { getMappedProperties, getPropertiesValues };
